import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../services/common.service';

@Injectable()
export class HttpInterceptor implements HttpInterceptor {
  constructor(private comSvc: CommonService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('https')) {
      return next.handle(request);
    }
   
    if (request.url.startsWith('noiseportal')) {
      const apiReq = request.clone({
        url: `${environment.BACKEND_API_URL}/${request.url}`,
      });
      return next.handle(apiReq);
    }

    return next.handle(request);
  }
}
